import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=4375bd3c&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4375bd3c')) {
      api.createRecord('4375bd3c', component.options)
    } else {
      api.reload('4375bd3c', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=4375bd3c&", function () {
      api.rerender('4375bd3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TermsAndConditions.vue"
export default component.exports